"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyList = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../common");
exports.CompanyList = react_1.default.memo(({ searchOption, initPage }) => {
    const countRef = react_1.default.useRef(10);
    const [page, setPage] = react_1.default.useState(initPage);
    const [totalCount, setTotalCount] = react_1.default.useState(120);
    const [testData, setTestData] = react_1.default.useState([]);
    const { headTitleList, tableReadDataKeys } = react_1.default.useMemo(() => {
        // 기본적인 항목들
        const headTitleList = [
            { title: 'companyName', space: 1 },
            { title: 'companyId', space: 1 },
            { title: 'url', space: 1 },
            { title: 'userId', space: 1 },
            { title: 'serviceSetting', space: 1 },
            { title: 'serviceStart', space: 1 },
            { title: 'serviceEnd', space: 1 },
        ];
        const tableReadDataKeys = [
            { title: 'name', space: 1 },
            { title: 'id', space: 1 },
            { title: 'url', space: 1 },
            { title: 'userId', space: 1 },
            { title: 'serviceSetting', space: 1 },
            { title: 'serviceStart', space: 1 },
            { title: 'serviceEnd', space: 1 },
        ];
        return { headTitleList, tableReadDataKeys };
    }, []);
    react_1.default.useEffect(() => {
        setPage(initPage);
    }, [initPage]);
    react_1.default.useEffect(() => {
        let list = [];
        for (let i = page * countRef.current; i < (page + 1) * countRef.current; i++) {
            list.push({
                name: 'companyName' + i,
                id: i,
                url: 'url' + i,
                userId: 'userId' + i,
                serviceSetting: 'serviceSetting' + i,
                serviceStart: 'serviceStart' + i,
                serviceEnd: 'serviceEnd' + i,
            });
        }
        setTestData(list);
    }, [page]);
    const handlerMoreData = (page) => {
        setPage(page);
        APP.eventManager.publish('UPDATE_PAGE', page);
    };
    const renderEmpty = react_1.default.useMemo(() => totalCount <= 0 && (react_1.default.createElement("div", { className: "empty_data" },
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uD68C\uC0AC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), [totalCount]);
    const renderItem = (item) => {
        if (!item)
            return;
        return tableReadDataKeys.map((headItem, idx) => (react_1.default.createElement("div", { key: idx, className: "table-item", style: {
                flex: headItem.space,
                justifyContent: 'flex-start',
                alignItems: 'center',
                display: 'flex',
                overflow: 'hidden',
            } },
            react_1.default.createElement("p", { className: "overText2" }, item[headItem.title]))));
    };
    const handlerSelectItem = (item) => {
        APP.eventManager.publish('CHANGE_MENU', {
            showDepth: 'detail',
            props: { id: item.id },
        });
    };
    return (react_1.default.createElement(common_1.Table, { isInnerPage: true, isInfinite: false, page: page, data: testData, totalCount: totalCount, headTitleList: headTitleList, renderItem: renderItem, renderEmpty: renderEmpty, handlerSelectItem: handlerSelectItem, handlerMoreData: handlerMoreData }));
});
